import axios from "axios";
export let baseURL = process.env.REACT_APP_BASEURL;

const axiosInstance = axios.create({ baseURL });
export default axiosInstance;
